// Backward-compat shim — YENİ sistem: LanguageContext (TR/EN çift dil)
// Eski `useContent()` import'ları çalışmaya devam eder ama artık LanguageContext'e delege eder
import { LanguageProvider, useLanguage } from "./LanguageContext";

export const ContentProvider = LanguageProvider;
export const useContent = useLanguage;

